export const API = process.env.REACT_APP_API_URL;
export const Theme_Color = '#1a3c8b'
export const APP_LOGO = './src/img/small_wecurify.png'